import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SimpleMDE from 'react-simplemde-editor'
import arraySort from 'array-sort'
import { FormattedMessage } from 'react-intl'

import MarkdownLabel from '../../mini/MarkdownLabel'
import SearchArea from '../../mini/SearchArea'
import NotYetSpecified from '../../mini/NotYetSpecified'

import { simpleMDEOptions } from '../../../utils/index'
import { fetchTags } from '../../../actions/tags'
import { tags, copyrightHolder } from '../../../utils/messages'

export default class OtherInformation extends Component {
  constructor(props) {
    super(props)
    this.handleUnusualMaterialsChangeBound =
      this.handleUnusualMaterialsChange.bind(this)
    this.handleTagChangeBound = this.handleTagChange.bind(this)
    this.handleInspirationAndUnusualCreditsChangeBound =
      this.handleInspirationAndUnusualCreditsChange.bind(this)
  }

  componentDidMount() {
    // make sure we're getting the newest list of tags when section is mounted
    this.props.dispatch(fetchTags())
  }

  componentWillReceiveProps(nextProps) {
    // TODO: Not the optimal solution, but if any of the quest tags are updated, refetch the tags
    // will ensure we're getting the latest list including any potentially newly added tags.
    // Ultimately, I'd rather fetch only if we know a new tag was created.
    if (this.props.quest.tags !== nextProps.quest.tags) {
      this.props.dispatch(fetchTags())
    }
  }

  render() {
    const { quest, isEditingQuest } = this.props

    const unusualMaterialsOptions = Object.assign({}, simpleMDEOptions)
    unusualMaterialsOptions.initialValue = quest.unusual_materials
    unusualMaterialsOptions.placeholder = ''
    unusualMaterialsOptions.autofocus = false

    const inspirationAndAdditionalCreditsOptions = Object.assign(
      {},
      simpleMDEOptions
    )
    inspirationAndAdditionalCreditsOptions.initialValue =
      quest.inspiration_and_additional_credits
    inspirationAndAdditionalCreditsOptions.placeholder = ''
    inspirationAndAdditionalCreditsOptions.autofocus = false

    return (
      <div className="basic-information">
        <div className="section-inner">
          <div className="title">
            <FormattedMessage
              id={'Quest.OtherInformation.UnusualMaterials'}
              defaultMessage={'Unusual Materials'}
            />
          </div>
          {isEditingQuest && (
            <div className="edit-fields">
              <SimpleMDE
                id="unusual_materials"
                options={unusualMaterialsOptions}
                onChange={this.handleUnusualMaterialsChangeBound}
              />
            </div>
          )}
          {!isEditingQuest && (
            <div className="view-fields">
              <MarkdownLabel
                id="view-unusual_materials"
                value={quest.unusual_materials}
              />
            </div>
          )}
          <div className="title">
            {tags}
            <div className="requiredtool" />
          </div>
          {isEditingQuest && (
            <div className="edit-fields">
              <SearchArea
                dispatch={this.props.dispatch}
                area="tags"
                placeholder="Select tags"
                values={this.formatTagsArray(quest.tags)}
                options={arraySort(this.mapList(this.props.tags), ['sort'])}
                handleChange={this.handleTagChangeBound}
                tagEdit
              />
            </div>
          )}
          {!isEditingQuest && (
            <div className="view-fields">
              {!quest.tags || quest.tags === '' ? (
                <NotYetSpecified />
              ) : (
                <label id="view-tags" className="">
                  {quest.tags}
                </label>
              )}
            </div>
          )}

          <div className="title">
            <FormattedMessage
              id={'Quest.OtherInformation.InspirationAndAdditionalCredits'}
              defaultMessage={'Inspiration And Additional Credits'}
            />
          </div>
          {isEditingQuest && (
            <div className="edit-fields">
              <p>
                <FormattedMessage
                  id={'Quest.OtherInformation.MentionPeople'}
                  defaultMessage={
                    'Mention people or materials that have inspired this quest that you want to give credit to.'
                  }
                />
              </p>
              <SimpleMDE
                id="inspiration_and_additional_credits"
                options={inspirationAndAdditionalCreditsOptions}
                onChange={this.handleInspirationAndUnusualCreditsChangeBound}
              />
            </div>
          )}
          {!isEditingQuest && (
            <div className="view-fields">
              <MarkdownLabel
                id="view-inspiration_and_additional_credits"
                value={quest.inspiration_and_additional_credits}
              />
            </div>
          )}

          <div>
            <div className="title">{copyrightHolder}</div>
            <label>{quest.organization.name}</label>
            <input
              type="hidden"
              id="copyrightHolder"
              value={quest.organization.name}
            />
          </div>

          <div className="creative-commons-section">
            <div className="title ilb">
              <FormattedMessage
                id={'Quest.OtherInformation.CreativeCommonsLicense'}
                defaultMessage={'CREATIVE COMMONS LICENSE'}
              />
            </div>
            <a
              className="ilb creative-commons-header"
              target="_blank"
              href="http://creativecommons.org/licenses/"
            >
              <FormattedMessage
                id={'Quest.OtherInformation.CreativeCommonsWebsite'}
                defaultMessage={'Creative Commons Website'}
              />
            </a>
            <div className="view-fields">
              <div className="license-version">
                <div className="title">
                  <FormattedMessage
                    id={'Quest.OtherInformation.LicenseAndVersion'}
                    defaultMessage={'License and Version'}
                  />
                </div>
                <label className="license-display">
                  {quest.license
                    ? quest.license.name
                    : 'This will be automatically generated.'}{' '}
                  {quest.license ? ', Version: ' + quest.license.version : ''}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleUnusualMaterialsChange(e) {
    // Hacky way to format the event id and value so parent's edit function works
    // The markdown editor makes this trickier than with a standard textfield
    let event = {
      target: {}
    }
    event.target.id = 'unusual_materials'
    event.target.value = e
    this.props.handleChange(event)
  }

  mapList(arr) {
    return arr.map(function (el) {
      return {
        value: el.id,
        label: el.name,
        sort: el.name.trim().toLowerCase()
      }
    })
  }

  formatTagsArray(tagsString) {
    const { tags } = this.props
    var tagsArray = []
    tagsString.split(', ').forEach(function (t) {
      tags.find(function (tag) {
        if (tag.name === t) {
          tagsArray.push({
            value: tag.id,
            label: tag.name,
            sort: tag.name.trim().toLowerCase()
          })
        }
      })
    })
    return tagsArray
  }

  async handleTagChange(values) {
    // Hacky way to format the event id and value so parent's edit function works
    let event = {
      target: {}
    }
    event.target.id = 'questtag_list'
    const tagsString = values.map(t => t.label).join()
    event.target.value = tagsString

    await this.props.handleChange(event)
  }

  handleInspirationAndUnusualCreditsChange(e) {
    // Hacky way to format the event id and value so parent's edit function works
    // The markdown editor makes this trickier than with a standard textfield
    let event = {
      target: {}
    }
    event.target.id = 'inspiration_and_additional_credits'
    event.target.value = e
    this.props.handleChange(event)
  }
}

OtherInformation.propTypes = {
  quest: PropTypes.object.isRequired,
  isEditingQuest: PropTypes.bool.isRequired,
  handleChange: PropTypes.func,
  dispatch: PropTypes.func,
  tags: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/components/quest/section/OtherInformation.js